import { render } from "./LandingNavigation.vue?vue&type=template&id=5835d6f1&scoped=true&lang=pug"
import script from "./LandingNavigation.vue?vue&type=script&lang=js"
export * from "./LandingNavigation.vue?vue&type=script&lang=js"

import "./LandingNavigation.vue?vue&type=style&index=0&id=5835d6f1&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5835d6f1"]])

export default __exports__